module.exports = __webpack_public_path__ + "static/dashboard_powder-800b9ecc9ef4fda220f8e762fa2fff5d.png";